export default __webpack_public_path__ + "static/media/getta_delivery_logo.0909129d.png";